module.exports = __webpack_public_path__ + "img/calendar-plus-02.2b0f7033.svg";